import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  debug: true,
  lng: "pt",
  fallbackLng: "pt",
  resources: {
    pt: {
      translation: {
        confirmPhone: "Confirme o Telefone",
        confirmPhoneDescription: `Confirme seu telefone para resgatar a oferta <strong>Deezer Premium</strong> do seu provedor de internet.`,
        phone: "Telefone:",
        confirmBySMS: "confirmar por sms",
        confirmByWhatsApp: "confirmar por whatsapp",
        enterCode: "Digite o código que você recebeu por",
        resendCode: "REENVIAR CÓDIGO",
        redeemCode: "RESGATAR CÓDIGO",
        errorGeneric: "Ops, ocorreu um problema...",
        resendLimitReached: "Limite de envios atingido.",
        resendCodeWithTimer: "Reenviar código ({{time}})",
        redeemCodeMin: "Resgatar Código",
        phoneRequired: "Telefone vazio",
        captchaRequired: "Confirme que você não é um robô",
        codeSentSuccess: "Código enviado com sucesso.",
        codeSendError: "Erro ao enviar o código. Tente novamente.",
        codeInvalidOrExpired: "Código inválido ou expirado.",
        codeRedeemError: "Erro ao resgatar o código. Tente novamente.",
        numberConfirmedTitle: "Parabéns, seu número foi confirmado!",
        numberConfirmedDescription_before:
          "Você receberá em instantes um link por SMS para continuar com a ativação do",
        numberConfirmedDescription_after:
          "Caso não receba o SMS, você pode continuar a ativação",
        clickHere: "clicando aqui",
        backButtonLabel: "Voltar",
        clickHere: "clique aqui",
      },
    },
    es: {
      translation: {
        confirmPhone: "Confirme el Teléfono",
        confirmPhoneDescription:
          "Confirme su teléfono para canjear la oferta de Deezer Premium de su proveedor de internet.",
        phone: "Teléfono:",
        confirmBySMS: "confirmar por sms",
        confirmByWhatsApp: "confirmar por whatsapp",
        enterCode: "Ingrese el código que recibió por",
        resendCode: "REENVIAR CÓDIGO",
        redeemCode: "CANJEAR CÓDIGO",
        errorGeneric: "Ups, ocurrió un problema...",
        resendLimitReached: "Límite de envíos alcanzado.",
        resendCodeWithTimer: "Reenviar código ({{time}})",
        redeemCodeMin: "Canjear Código",
        phoneRequired: "Teléfono vacío",
        captchaRequired: "Confirme que no es un robot",
        codeSentSuccess: "Código enviado con éxito.",
        codeSendError: "Error al enviar el código. Inténtelo de nuevo.",
        codeInvalidOrExpired: "Código inválido o expirado.",
        codeRedeemError: "Error al canjear el código. Inténtelo de nuevo.",
        numberConfirmedTitle: "¡Felicidades, su número fue confirmado!",
        numberConfirmedDescription_before:
          "En breve recibirá un enlace por SMS para continuar con la activación de",
        numberConfirmedDescription_after:
          "Si no recibe el SMS, puede continuar la activación",
        clickHere: "haciendo clic aquí",
        backButtonLabel: "Volver",
        clickHere: "haga clic aquí",
      },
    },
  },
});

export default i18n;
